import { z } from "zod";
import { type IntlShape } from "react-intl";

import {
	getPickZoneConfigurationSchema,
	getPickZoneSchema,
	getPickZoneStatusUpdateSchema,
	type PickZone,
	type PickZoneConfiguration,
	type PickZoneStatusUpdate,
} from "@/schemas/pick-zone";
import { baseRoutes } from "@/api/base-routes";
import { packNetAxios } from "@/lib/api-client";

const pickZonesSchema = (intl: IntlShape) => z.array(getPickZoneSchema(intl));

export async function getPickZones(intl: IntlShape): Promise<PickZone[]> {
	const response = await packNetAxios.get(`${baseRoutes.selection}/v2/pickzones`);

	return pickZonesSchema(intl).enrich({ callSite: "getPickZones" }).parseWithTelemetry(response.data);
}

export async function updatePickZoneStatus(
	pickZoneId: string,
	data: PickZoneStatusUpdate,
	intl: IntlShape,
): Promise<void> {
	return packNetAxios.patch(
		`${baseRoutes.selection}/v2/pickzones/${pickZoneId}/status`,
		getPickZoneStatusUpdateSchema(intl).enrich({ callSite: "updatePickZoneStatus" }).parseWithTelemetry(data),
	);
}

export function deletePickZone(id: string): Promise<void> {
	return packNetAxios.delete(`${baseRoutes.selection}/v2/pickzones/${id}`);
}

export function createPickZone(pickZoneConfiguration: PickZoneConfiguration, intl: IntlShape): Promise<void> {
	return packNetAxios.post(
		`${baseRoutes.selection}/v2/pickzones`,
		getPickZoneConfigurationSchema(intl)
			.enrich({ callSite: "createPickZone" })
			.parseWithTelemetry(pickZoneConfiguration),
	);
}

export function updatePickZone(
	pickZoneId: string,
	pickZoneConfiguration: PickZoneConfiguration,
	intl: IntlShape,
): Promise<void> {
	return packNetAxios.patch(
		`${baseRoutes.selection}/v2/pickzones/${pickZoneId}`,
		getPickZoneConfigurationSchema(intl)
			.enrich({ callSite: "updatePickZone" })
			.parseWithTelemetry(pickZoneConfiguration),
	);
}

export function restorePickZone(pickZoneId: string, pickZone: PickZone, intl: IntlShape): Promise<void> {
	return packNetAxios.put(
		`${baseRoutes.selection}/v2/pickzones/${pickZoneId}`,
		getPickZoneSchema(intl).enrich({ callSite: "restorePickZone" }).parseWithTelemetry(pickZone),
	);
}
